class InstagramCarousel extends HTMLElement {
  constructor() {
    super();
    // 仅缓存模态框根元素，按钮元素延迟查询
    this.instagramModalEl = this.querySelector('.js-instagram-modal');
  }

  connectedCallback() {
    this.initCarouselInstagram();
    this.openInstagramModal();
    this.setupCloseHandlers(); // 统一处理所有关闭逻辑
  }

  initCarouselInstagram() {
    const sectionId = this.dataset.sectionId;
    this.swiperInsta = new Swiper(`.js-instagram-carousel-${sectionId} .swiper`, {
      slidesPerView: 1.7,
      centeredSlides: true,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 18,
          centeredSlides: true
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 20,
          centeredSlides: false
        },
      },
    });
  }

  openInstagramModal() {
    if (this.swiperInsta) {
      this.swiperInsta.on('click', (swiper) => {
        const slides = swiper.slides;
        const currentIndex = swiper.clickedIndex;
        const blockId = slides[currentIndex].dataset.blockId;
        const contentModal = this.querySelector(`.js-modal-content[data-block-id="${blockId}"]`);

        this.removeAllClassActive(this.querySelectorAll('.js-modal-content'), 'is-content-active');
        this.instagramModalEl?.classList.add('is-active');
        contentModal?.classList.add('is-content-active');
      });
    }
  }

  setupCloseHandlers() {
    if (!this.instagramModalEl) return;

    // 方法1：事件委托（推荐，兼容动态元素和SVG）
    this.instagramModalEl.addEventListener('click', (e) => {
      // 检测所有可能的关闭触发源
      const isCloser = 
        e.target.closest('.js-close-modal') ||  // 常规按钮
        e.target.closest('.close_btn') ||      // 备用按钮类名
        e.target.classList.contains('js-close-modal') ||  // SVG自身
        e.target.parentElement.classList.contains('js-close-modal'); // SVG子元素

      if (isCloser) {
        this.instagramModalEl.classList.remove('is-active');
        e.stopPropagation(); // 防止事件冒泡干扰
      }
      
      // 可选：点击模态框背景关闭
      if (e.target === this.instagramModalEl) {
        this.instagramModalEl.classList.remove('is-active');
      }
    });

    // 方法2：直接绑定（静态元素备用方案）
    const closeButtons = [
      ...this.querySelectorAll('.js-close-modal'), 
      ...this.querySelectorAll('.close_btn')
    ];
    closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.instagramModalEl?.classList.remove('is-active');
        e.stopPropagation();
      });
    });
  }

  removeAllClassActive(items, classActive) {
    items?.forEach(item => item.classList.remove(classActive));
  }

  openInstagramModal() {
    if (this.swiperInsta) {
      this.swiperInsta.on('click', (swiper) => {
        const slides = swiper.slides;
        const currentIndex = swiper.clickedIndex;
        const blockId = slides[currentIndex].dataset.blockId;
        const contentModal = this.querySelector(`.js-modal-content[data-block-id="${blockId}"]`);

        this.removeAllClassActive(this.querySelectorAll('.js-modal-content'), 'is-content-active');
        this.instagramModalEl?.classList.add('is-active');
        contentModal?.classList.add('is-content-active');

        // 🔥 关键修改：在模态框显示后初始化/更新 Swiper
        this.initModalSwiper(blockId);
      });
    }
  }

  initModalSwiper(blockId) {
    const modalSwiperEl = this.querySelector(`.js-instagram-modal-img-${blockId} .swiper`);
    if (!modalSwiperEl || modalSwiperEl.swiper) return; // 避免重复初始化

    new Swiper(modalSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: modalSwiperEl.querySelector('.swiper-button-next'), // 限定在当前模态框
        prevEl: modalSwiperEl.querySelector('.swiper-button-prev')  // 限定在当前模态框
      },
      pagination: {
        el: modalSwiperEl.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }
}

// 注册Web Component
if (!customElements.get("instagram-carousel")) {
  customElements.define("instagram-carousel", InstagramCarousel);
}